import { render, staticRenderFns } from "./LiableFieldForm.vue?vue&type=template&id=1f9e672a&"
import script from "./LiableFieldForm.vue?vue&type=script&lang=js&"
export * from "./LiableFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./LiableFieldForm.vue?vue&type=style&index=0&id=1f9e672a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports